<div class="settingMessage">
  <mat-spinner data-cy="project-setup-loading-spinner" [diameter]="48" />
  <p>Loading project data</p>
</div>
